import Layout from "../../hocs/Layout";
import { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { login } from "../../redux/actions/auth";
import { InfinitySpin } from "react-loader-spinner";
import { setAlert } from "../../redux/actions/alert";
import axios from "axios";
import GOOGLE_LOGO_URL from "../../assets/google.svg";
import MICROSOFT_LOGO_URL from "../../assets/microsoft.svg";
const Login = ({ login, loading, setAlert, isAuthenticated }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { email, password } = formData;

  const [activated, setActivated] = useState(false);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    const result = await login(email, password);

    if (result.status === 200) {
      setActivated(true);
    } else if (
      result.status === 401 &&
      result.data.detail ===
        "No active account found with the given credentials"
    ) {
      setAlert(
        "Account not activated. Please check your email and activate your account.",
        "red"
      );
    } else {
      setAlert(`Error: ${result.data.detail}`, "red");
    }
  };

  // Lógica para continuar con Google
  const continueWithGoogle = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/o/google-oauth2/?redirect_uri=${process.env.REACT_APP_API_URL}/google`
      );
      window.location.replace(res.data.authorization_url);
    } catch (err) {
      setAlert("Error connecting with Google", "red");
    }
  };
  
  const continueWithMicrosoft = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/o/azuread-oauth2/?redirect_uri=${process.env.REACT_APP_API_URL}/microsoft`
      );
      window.location.replace(res.data.authorization_url);
    } catch (err) {
      setAlert("Error connecting with Microsoft", "red");
    }
  };



  if (activated || isAuthenticated) return <Navigate to="/" />;

  return (
    <Layout>
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-white">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Or{" "}
            <Link
              to="/signup"
              className="font-medium text-emerald-600 hover:text-emerald-500"
            >
              Sign up
            </Link>
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          {/* Card */}
          <div className="py-8 px-10 shadow sm:rounded-lg sm:px-10 bg-white">
            {/* FORMULARIO DE EMAIL Y PASSWORD */}
            <form onSubmit={onSubmit} className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <div className="mt-1">
                  <input
                    name="email"
                    value={email}
                    onChange={onChange}
                    type="email"
                    placeholder="Enter your email"
                    required
                    className="appearance-none block w-full px-3 py-2 
                               border border-gray-300 rounded-md shadow-sm 
                               placeholder-gray-400 focus:outline-none 
                               focus:ring-emerald-500 focus:border-emerald-500 
                               sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <div className="mt-1">
                  <input
                    name="password"
                    value={password}
                    onChange={onChange}
                    type="password"
                    placeholder="Enter your password"
                    required
                    className="appearance-none block w-full px-3 py-2 
                               border border-gray-300 rounded-md shadow-sm 
                               placeholder-gray-400 focus:outline-none 
                               focus:ring-emerald-500 focus:border-emerald-500 
                               sm:text-sm"
                  />
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 
                               border-gray-300 rounded"
                  />
                  <label
                    htmlFor="remember-me"
                    className="ml-2 block text-sm text-gray-700"
                  >
                    Remember me
                  </label>
                </div>
                <div className="text-sm">
                  <Link
                    to="/reset_password"
                    className="font-medium text-emerald-600 hover:text-emerald-500"
                  >
                    Forgot your password?
                  </Link>
                </div>
              </div>

              {/* BOTÓN DE LOGIN (EMAIL/PASSWORD) */}
              <div>
                {loading ? (
                  <button
                    disabled
                    className="w-full flex justify-center py-2 px-4 
                               border border-transparent rounded-md shadow-sm 
                               text-sm font-medium text-white bg-emerald-600 
                               hover:bg-emerald-700 focus:outline-none 
                               focus:ring-2 focus:ring-offset-2 
                               focus:ring-emerald-500"
                  >
                    <InfinitySpin
                      type="Oval"
                      color="#fff"
                      width={20}
                      height={20}
                    />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="w-full flex justify-center py-2 px-4 
                               border border-transparent rounded-md shadow-sm 
                               text-sm font-medium text-white bg-emerald-600 
                               hover:bg-emerald-700 focus:outline-none 
                               focus:ring-2 focus:ring-offset-2 
                               focus:ring-emerald-500"
                  >
                    Sign in
                  </button>
                )}
              </div>
            </form>

            {/* SEPARADOR */}
            <div className="flex items-center my-6">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="mx-2 text-gray-500">OR</span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>

             <button
              onClick={continueWithGoogle}
              type="button"
              className="w-full inline-flex items-center justify-center
             py-2 px-4 border border-gray-300 rounded-md shadow-sm
             bg-white text-gray-700 hover:bg-gray-50
             focus:outline-none focus:ring-2 focus:ring-offset-2
             focus:ring-gray-400"
            >
              <img
                src={GOOGLE_LOGO_URL}
                alt="Google Logo"
                className="h-5 w-5 mr-2"
              />
              Continue with Google
            </button>

            <div className="mt-4">
              <button
                onClick={continueWithMicrosoft}
                type="button"
                className="w-full inline-flex items-center justify-center
               py-2 px-4 border border-gray-300 rounded-md shadow-sm
               bg-white text-gray-700 hover:bg-gray-50
               focus:outline-none focus:ring-2 focus:ring-offset-2
               focus:ring-gray-400"
              >
                <img
                  src={MICROSOFT_LOGO_URL}
                  alt="Microsoft Logo"
                  className="h-5 w-5 mr-2"
                />
                Continue with Microsoft
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
  loading: state.Auth.loading,
});

export default connect(mapStateToProps, { login, setAlert })(Login);
